import { Action, createReducer, on } from '@ngrx/store';

import { ProductSubcategoriesState } from './product-subcategories-state.type';
import { ProductSubcategoriesActions } from './product-subcategories.actions';

import { DpProductSubcategoriesSwitcherModel } from '../models';

const initialState: ProductSubcategoriesState = {
  switcher: new DpProductSubcategoriesSwitcherModel()
};

const reducer = createReducer(
  initialState,
  on(
    ProductSubcategoriesActions.loadProductSubcategoriesSuccess,
    (state, { categories }): ProductSubcategoriesState => ({
      ...state,
      categories,
      switcher: new DpProductSubcategoriesSwitcherModel(
        0,
        state.switcher.visibleItemsCount,
        categories.subcategories.length
      )
    })
  ),
  on(
    ProductSubcategoriesActions.setActiveSubcategories,
    (state, { activeIndex }): ProductSubcategoriesState => ({
      ...state,
      switcher: new DpProductSubcategoriesSwitcherModel(
        activeIndex,
        state.switcher.visibleItemsCount,
        state.categories?.subcategories?.length
      )
    })
  ),

  on(
    ProductSubcategoriesActions.setVisibleItemsCount,
    (state, { visibleItemsCount }): ProductSubcategoriesState => ({
      ...state,
      switcher: new DpProductSubcategoriesSwitcherModel(
        state.switcher.currentIndex,
        visibleItemsCount,
        state.categories?.subcategories?.length
      )
    })
  )
);

export const productSubcategoriesReducers = (
  state: ProductSubcategoriesState,
  action: Action
): ProductSubcategoriesState => reducer(state, action);
